import { render, staticRenderFns } from "./Apk.vue?vue&type=template&id=a2f25e9a"
import script from "./Apk.vue?vue&type=script&lang=js"
export * from "./Apk.vue?vue&type=script&lang=js"
import style0 from "./Apk.vue?vue&type=style&index=0&id=a2f25e9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports